import instance from "../../Config/axios";
import jwt from "jwt-decode";
export const userLogin = async (formData) => {
  const responseData = {
    loading: false,
    status: 210,
    message: "Something went wrong, Please try again.",
  };
  return instance
    .post("users/login", formData)
    .then((response) => {
      if (
        response.data &&
        response.status === 200 &&
        response.data.msg === "Successful"
      ) {
        response = response.data;
        sessionStorage.setItem("token", response?.token);
        if (response.user.fa2Status == false) {
          localStorage.setItem("token", response?.token);
          // setJwtToken("token", response?.token);
          localStorage.setItem("user", JSON.stringify(response?.user));
          localStorage.setItem(
            "rights",
            JSON.stringify(response?.user?.rights[0])
          );
          localStorage.setItem(
            "role",
            response?.user?.admin
              ? "admin"
              : response?.user?.superAdmin
              ? "superAdmin"
              : "user"
          );
          localStorage.setItem(
            "permissions",
            response?.user?.permissions ? response?.user?.permissions : "user"
          );
        }
        // window.location.href = "/dashboard";
        return {
          ...responseData,
          role: response?.user?.admin
            ? "admin"
            : response?.user?.superAdmin
            ? "superAdmin"
            : "user",
          status: 200,
          auth: response.user.fa2Status,
          message: response.msg,
          user: response?.user,
        };
      } else {
        return {
          ...responseData,
          message: response.data.msg,
          status: 300,
        };
      }
    })
    .catch((err) => {
      return {
        ...responseData,
        message: "SERVER ERROR",
      };
    });
};
export function getJwtToken() {
  return sessionStorage.getItem("jwt");
}

export function setJwtToken(token) {
  let jwtToken = token.split(" ")[1];
  const user = jwt(jwtToken);
  sessionStorage.setItem("expire", user.exp);
  sessionStorage.setItem("token", token);
}

// Longer duration refresh token (30-60 min)
export function getRefreshToken() {
  return sessionStorage.getItem("refreshToken");
}

export function setRefreshToken(token) {
  sessionStorage.setItem("refreshToken", token);
}
// const parseJwt = (token) => {
//   try {
//     let jwtToken = token.split(" ")[1];
//     const user = jwt(jwtToken);
//     return user;
//   } catch (e) {
//     return null;
//   }
// };
